import PropTypes from "prop-types";

const stringOrNumber = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
]);

// media types
const types = {
  screen: PropTypes.bool,
};

// properties that match media queries
const matchers = {
  width: stringOrNumber,
  type: Object.keys(types),
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { type, ...featureMatchers } = matchers;

// media features
const features = {
  minWidth: stringOrNumber,
  maxWidth: stringOrNumber,
  ...featureMatchers,
};

const all = { ...types, ...features };

export default {
  all,
  types,
  matchers,
  features,
};
